// src/data/chakraData.js

export const chakraData = [
  {
    id: 1,
    name: "Root Chakra",
    sanskritName: "Muladhara",
    color: "#FF0000",
    position: "Base of spine",
    element: "Earth",
    mantra: "LAM",
    
    frequency: "396 Hz",
    description: "The Root Chakra forms our foundation. It represents our connection to the earth, our physical body, and our ability to feel safe and secure.",
    crystals: ["Ruby", "Garnet", "Black Tourmaline", "Bloodstone", "Red Jasper", "Hematite"],
    doshas: ["Kapha"],
    doshaInfluence: "Provides stability and grounding energy, supporting Kapha's earth-like qualities",
    physicalAspects: [
      "Skeletal structure",
      "Legs and feet",
      "Large intestine",
      "Adrenal glands",
      "Blood",
      "Spine (base)"
    ],
    emotionalAspects: [
      "Security and safety",
      "Basic survival needs",
      "Grounding",
      "Trust in the world",
      "Self-preservation",
      "Tribal/family connections"
    ],
    healingPractices: [
      "Walking barefoot in nature",
      "Root chakra meditation",
      "Mountain Pose (Tadasana)",
      "Working with red crystals",
      "Grounding exercises",
      "Drumming meditation"
    ],
    balancingFoods: [
      "Root vegetables",
      "Red foods",
      "Protein-rich foods",
      "Spices: Black pepper, ginger",
      "Nuts and seeds",
      "Red meat (if part of diet)"
    ]
  },
  {
    id: 2,
    name: "Sacral Chakra",
    sanskritName: "Swadhisthana",
    color: "#FF8C00",
    position: "Lower abdomen",
    element: "Water",
    mantra: "VAM",
    frequency: "417 Hz",
    description: "The Sacral Chakra governs our creativity, emotions, and sensuality. It influences our ability to go with the flow of life and experience pleasure.",
    crystals: ["Orange Calcite", "Carnelian", "Tiger's Eye", "Moonstone", "Coral", "Amber"],
    doshas: ["Pitta", "Kapha"],
    doshaInfluence: "Balances emotional fluidity and creative expression, harmonizing water elements",
    physicalAspects: [
      "Reproductive system",
      "Lower back",
      "Hips",
      "Sacrum",
      "Bladder",
      "Water retention"
    ],
    emotionalAspects: [
      "Creativity",
      "Passion",
      "Sensuality",
      "Emotional balance",
      "Pleasure",
      "Relationships"
    ],
    healingPractices: [
      "Dance movement",
      "Hip-opening yoga poses",
      "Creative expression",
      "Water meditation",
      "Moon bathing",
      "Artistic activities"
    ],
    balancingFoods: [
      "Orange fruits",
      "Sweet foods",
      "Water-rich foods",
      "Cinnamon, vanilla",
      "Tropical fruits",
      "Honey"
    ]
  },
  {
    id: 3,
    name: "Solar Plexus Chakra",
    sanskritName: "Manipura",
    color: "#FFFF00",
    position: "Upper abdomen",
    element: "Fire",
    mantra: "RAM",
    frequency: "528 Hz",
    description: "The Solar Plexus Chakra is our center of personal power, self-esteem, and confidence. It governs our ability to be confident and in control of our lives.",
    crystals: ["Citrine", "Yellow Topaz", "Tiger's Eye", "Amber", "Pyrite", "Yellow Calcite"],
    doshas: ["Pitta"],
    doshaInfluence: "Enhances transformation and metabolism, strengthening Pitta's fire element",
    physicalAspects: [
      "Digestive system",
      "Pancreas",
      "Liver",
      "Gallbladder",
      "Metabolism",
      "Core muscles"
    ],
    emotionalAspects: [
      "Personal power",
      "Self-confidence",
      "Self-esteem",
      "Willpower",
      "Motivation",
      "Achievement"
    ],
    healingPractices: [
      "Core strengthening exercises",
      "Sun salutations",
      "Power yoga",
      "Fire breathing",
      "Martial arts",
      "Solar meditation"
    ],
    balancingFoods: [
      "Yellow foods",
      "Whole grains",
      "Spices: Turmeric, ginger",
      "Citrus fruits",
      "Complex carbohydrates",
      "Bananas"
    ]
  },
  {
    id: 4,
    name: "Heart Chakra",
    sanskritName: "Anahata",
    color: "#00FF00",
    position: "Center of chest",
    element: "Air",
    mantra: "YAM",
    frequency: "639 Hz",
    description: "The Heart Chakra is the bridge between the lower (physical) and upper (spiritual) chakras. It is our center of love, compassion, and connection.",
    crystals: ["Rose Quartz", "Green Aventurine", "Jade", "Malachite", "Emerald", "Green Tourmaline"],
    doshas: ["Vata", "Kapha"],
    doshaInfluence: "Promotes balance between movement and stability, harmonizing air and earth elements",
    physicalAspects: [
      "Heart",
      "Lungs",
      "Chest",
      "Arms",
      "Hands",
      "Thymus gland"
    ],
    emotionalAspects: [
      "Love",
      "Compassion",
      "Forgiveness",
      "Empathy",
      "Self-love",
      "Relationships"
    ],
    healingPractices: [
      "Heart-opening yoga poses",
      "Loving-kindness meditation",
      "Deep breathing exercises",
      "Forgiveness practices",
      "Gratitude journaling",
      "Service to others"
    ],
    balancingFoods: [
      "Green vegetables",
      "Green tea",
      "Air-cleaning herbs",
      "Leafy greens",
      "Sprouts",
      "Green apples"
    ]
  },
  {
    id: 5,
    name: "Throat Chakra",
    sanskritName: "Vishuddha",
    color: "#0000FF",
    position: "Throat",
    element: "Ether/Space",
    mantra: "HAM",
    frequency: "741 Hz",
    description: "The Throat Chakra is our center of communication, self-expression, and truth. It governs our ability to speak our truth and express ourselves clearly.",
    crystals: ["Blue Lace Agate", "Sodalite", "Aquamarine", "Turquoise", "Lapis Lazuli", "Celestite"],
    doshas: ["Vata"],
    doshaInfluence: "Enhances clear communication and expression, supporting Vata's ether element",
    physicalAspects: [
      "Throat",
      "Thyroid",
      "Neck",
      "Mouth",
      "Ears",
      "Voice"
    ],
    emotionalAspects: [
      "Communication",
      "Self-expression",
      "Truth-speaking",
      "Creativity",
      "Active listening",
      "Personal integrity"
    ],
    healingPractices: [
      "Chanting",
      "Singing",
      "Neck exercises",
      "Writing",
      "Public speaking",
      "Blue color therapy"
    ],
    balancingFoods: [
      "Blue/purple fruits",
      "Herbal teas",
      "Sea vegetables",
      "Water",
      "Raw honey",
      "Fruit juices"
    ]
  },
  {
    id: 6,
    name: "Third Eye Chakra",
    sanskritName: "Ajna",
    color: "#4B0082",
    position: "Between eyebrows",
    element: "Light",
    mantra: "OM",
    frequency: "852 Hz",
    description: "The Third Eye Chakra is our center of intuition, wisdom, and inner vision. It governs our ability to see clearly and trust our inner knowing.",
    crystals: ["Amethyst", "Lapis Lazuli", "Sodalite", "Purple Fluorite", "Azurite", "Labradorite"],
    doshas: ["Vata", "Pitta"],
    doshaInfluence: "Enhances intuition and clarity, balancing air and fire elements",
    physicalAspects: [
      "Brain",
      "Eyes",
      "Pineal gland",
      "Nervous system",
      "Forehead",
      "Sinuses"
    ],
    emotionalAspects: [
      "Intuition",
      "Wisdom",
      "Clarity",
      "Imagination",
      "Psychic abilities",
      "Inner guidance"
    ],
    healingPractices: [
      "Meditation",
      "Visualization",
      "Dream journaling",
      "Third eye exercises",
      "Yoga nidra",
      "Crystal healing"
    ],
    balancingFoods: [
      "Purple foods",
      "Brain-boosting foods",
      "Omega-3 rich foods",
      "Dark chocolate",
      "Blueberries",
      "Grape juice"
    ]
  },
  {
    id: 7,
    name: "Crown Chakra",
    sanskritName: "Sahasrara",
    color: "#9400D3",
    position: "Top of head",
    element: "Cosmic Energy/Consciousness",
    mantra: "AUM",
    frequency: "963 Hz",
    description: "The Crown Chakra is our connection to divine consciousness and spiritual awareness. It represents our ability to be fully connected spiritually.",
    crystals: ["Clear Quartz", "Amethyst", "Diamond", "Selenite", "Moonstone", "White Topaz"],
    doshas: ["Beyond doshas"],
    doshaInfluence: "Transcends physical elements, connecting to pure consciousness",
    physicalAspects: [
      "Brain",
      "Pineal gland",
      "Central nervous system",
      "Skull",
      "Cerebral cortex",
      "Consciousness"
    ],
    emotionalAspects: [
      "Spiritual connection",
      "Divine wisdom",
      "Universal consciousness",
      "Enlightenment",
      "Inner peace",
      "Unity"
    ],
    healingPractices: [
      "Silent meditation",
      "Prayer",
      "Crown chakra yoga",
      "Sound healing",
      "Energy work",
      "Spiritual study"
    ],
    balancingFoods: [
      "Fasting",
      "Pure water",
      "Light foods",
      "White foods",
      "Spiritual nutrition",
      "Detoxifying foods"
    ]
  }
];

export default chakraData;
